import React, { Fragment } from "react";
import { Route, Navigate } from "react-router-dom";

// import RegisterContainer from "../pages/RegisterContainer";
// import ResetPasswordContainer from "../pages/ResetPasswordContainer";
import Dashboard from "./pages/main";

import GuestGuard from "./components/Guards/GuestGuard";
import LoginContainer from "./pages/LoginContainer";
import AuthGuard from "./components/Auth/GuestGuard";
import InsidePanelsLayout from "./components/InsidePanelsLayout";

export const renderRoutes = (
  routes = [],
  tguard = Fragment,
  tLayout = Fragment
) => {
  return routes.map((route, i) => {
    const Guard = route.guard || tguard;
    const Layout = route.layout || tLayout;
    const Component = route.component;

    // اگر زیرمسیر دارد، بازگشتی ایجاد کن
    if (route.routes) {
      return renderRoutes(route.routes, Guard, Layout);
    }

    // مسیر ساده
    return (
      <Route
        key={`route-${i}`}
        path={route.path}
        element={
          route.element ? (
            route.element
          ) : (
            <Guard>
              <Layout>
                <Component />
              </Layout>
            </Guard>
          )
        }
      />
    );
  });
};

const routes = [
  {
    path: "/",
    element: <Navigate to="/login" />,
  },
  {
    path: "/login",
    guard: GuestGuard,
    layout: Fragment,
    component: LoginContainer,
  },
  // {
  //   path: "/register",
  //   guard: GuestGuard,
  //   layout: Fragment,
  //   component: RegisterContainer,
  // },
  // {
  //   path: "/reset-password",
  //   guard: GuestGuard,
  //   layout: Fragment,
  //   component: ResetPasswordContainer,
  // },
  {
    path: "*",
    guard: AuthGuard,
    layout: InsidePanelsLayout,
    routes: [
      {
        path: "/dashboard-page",
        component: Dashboard,
      },
      {
        exact: true,
        path: "/EntryModificationPhrase",
        component: React.lazy(() => import("./pages/EntryModificationPhrase")),
        name: "ورود و اصلاح جملات",
      },
      {
        exact: true,
        path: "/CommunityDetection",
        component: React.lazy(() => import("./pages/CommunityDetection")),
        name: "تشخیص جوامع",
      },
      {
        exact: true,
        path: "/VirusDetection",
        component: React.lazy(() => import("./pages/VirusDetection")),
        name: "تشخیص ویروسی شدن",
      },
      {
        exact: true,
        path: "/LeaderDetection",
        component: React.lazy(() => import("./pages/LeaderDetection")),
        name: "رهبران عقیده",
      },
      {
        exact: true,
        path: "/treePrediction",
        component: React.lazy(() => import("./pages/treePrediction")),
        name: "پیش‌بینی انشار پیام",
      },
      {
        exact: true,
        path: "/publisherSuggestion",
        component: React.lazy(() => import("./pages/publisherSuggestion")),
        name: "یشنهاد بهترین فرد و زمان جهت انشتار پیام",
      },
      {
        exact: true,
        path: "/publisherSuggestion/network",
        component: React.lazy(() => import("./pages/PublisherSuggestionNetwork")),
        name: "بهینه‌سازی انتشار در کل شبکه توییتر",
      },
      {
        exact: true,
        path: "/publisherSuggestion/selected-leaders",
        component: React.lazy(() =>
          import("./pages/PublisherSuggestionSelectedLeaders")
        ),
        name: "بهینه‌سازی انتشار میان رهبران منتخب در توییتر",
      },
      {
        exact: true,
        path: "/RumorDetection",
        component: React.lazy(() => import("./pages/RumorDetection")),
        name: "تشخیص شایعه",
      },
      {
        path: "*",
        element: <Navigate to="/dashboard-page" />,
      },
    ],
  },
];

export default routes;
